// extracted by mini-css-extract-plugin
export default {"grid":"GalleryImages_grid__3wZcW","imageWrapper":"GalleryImages_imageWrapper__zZ-9C","image":"GalleryImages_image__kjMCi","caption":"GalleryImages_caption__JbO3v"};